import { ArticleParagraph2, ArrowDownS16 } from '@cian/ui-kit';

import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export type TSelectButtonProps = {
  isOpened: boolean;
  isPlaceholderLabel: boolean;
  label: string;
  onClick: VoidFunction;
};

export const SelectButton: React.FC<TSelectButtonProps> = props => {
  const { isOpened, label, onClick, isPlaceholderLabel } = props;

  return (
    <div className={cn(styles['root'], isOpened && styles['opened'])} onClick={onClick} role="button">
      <ArticleParagraph2 color={isPlaceholderLabel ? 'gray40_100' : 'black_100'}>{label}</ArticleParagraph2>

      <span className={styles['icon']}>
        <ArrowDownS16 color="primary_100" />
      </span>
    </div>
  );
};

SelectButton.displayName = 'SelectButton';
